// extracted by mini-css-extract-plugin
export default {"banner":"Banner_banner__7KCUI","logo":"Banner_logo__kA10D","tagline":"Banner_tagline__NcLmr","bannerContent":"Banner_bannerContent__k6pPj"};